/**
 * ✅ HELPER: Normaliza JWT token removendo aspas, prefixos e formatação incorreta
 * 
 * Entrada: raw (string|null|undefined)
 * Saída: JWT puro (string) ou null
 * 
 * Normalizações aplicadas:
 * - trim
 * - remover prefixo "Bearer " (case-insensitive)
 * - remover aspas simples ou duplas envoltas
 * - se parecer JSON (começa com " e termina com "), tentar JSON.parse
 * - decodeURIComponent (caso venha URL encoded)
 */
export const normalizeJwtToken = (raw) => {
  if (!raw) {
    return null;
  }

  // Converter para string
  let token = String(raw);

  // 1. Trim
  token = token.trim();

  if (!token) {
    return null;
  }

  // 2. Remover prefixo "Bearer " (case-insensitive)
  if (token.toLowerCase().startsWith('bearer ')) {
    token = token.substring(7).trim();
  }

  // 3. Remover aspas duplas envoltas
  if (token.startsWith('"') && token.endsWith('"') && token.length > 2) {
    token = token.substring(1, token.length - 1).trim();
  }

  // 4. Remover aspas simples envoltas
  if (token.startsWith("'") && token.endsWith("'") && token.length > 2) {
    token = token.substring(1, token.length - 1).trim();
  }

  // 5. Se parecer JSON (começa com " e termina com "), tentar JSON.parse
  if (token.startsWith('"') && token.endsWith('"')) {
    try {
      const parsed = JSON.parse(token);
      if (typeof parsed === 'string') {
        token = parsed;
      }
    } catch (e) {
      // Ignorar erro de parse - continuar com token original
    }
  }

  // 6. Tentar decodeURIComponent (caso venha URL encoded)
  try {
    const decoded = decodeURIComponent(token);
    // Se decodeURIComponent não mudou nada, usar original
    // Se mudou, usar decoded
    if (decoded !== token && decoded.length > 0) {
      token = decoded;
    }
  } catch (e) {
    // Ignorar erro de decode - continuar com token original
  }

  // 7. Trim final
  token = token.trim();

  // 8. Validar que parece um JWT (começa com eyJ)
  if (token && token.length > 10 && token.startsWith('eyJ')) {
    return token;
  }

  // Se não parece JWT, retornar null
  return null;
};

export default normalizeJwtToken;
